import clsx from "clsx";
import React from "react";
/**
 * 导航组件
 *  leading  React.Node[]
 *  title React.Node
 *  trailing React.Node[]
 */
export interface NavigationBarProps {
	leading?: React.ReactNode[];
	title?: string;
	trailing?: React.ReactNode[];
	className?: string;
	tradingWidth?: string;
}

export default function NavigationBar(props: NavigationBarProps) {
	const actionWidth = () => {
		const leadingLen = props.leading ? props.leading.length : 0;
		const trailingLen = props.trailing ? props.trailing.length : 0;
		const len = Math.max(leadingLen, trailingLen);
		const width = len * 20 + (len - 1) * 16;
		return len > 0 ? `${width}px` : "";
	};

	return (
		<div className={clsx("flex h-12 items-center", props.className)}>
			<div className="inline-flex flex-shrink-0" style={{ width: actionWidth() }}>
				{props.leading && props.leading.map((item) => item)}
			</div>

			<div className="flex-1 truncate px-4 text-center text-sm font-semibold h-5 leading-5  -mt-[2px]">
				{props.title}
			</div>

			<div
				className="inline-flex flex-shrink-0 justify-end items-center"
				style={{ width: props.tradingWidth || actionWidth() }}
			>
				{props.trailing && props.trailing.map((item) => item)}
			</div>
		</div>
	);
}
